import { render, staticRenderFns } from "./custom-message-popup.vue?vue&type=template&id=636d5d67&scoped=true&"
import script from "./custom-message-popup.vue?vue&type=script&lang=tsx&"
export * from "./custom-message-popup.vue?vue&type=script&lang=tsx&"
import style0 from "./custom-message-popup.vue?vue&type=style&index=0&id=636d5d67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d5d67",
  null
  
)

export default component.exports